import { CSSProperties, HTMLAttributes } from 'react'
import classNames from 'classnames'
import { BoxProps } from '@alto-avios/alto-ui'
import { AlertProvider, AlertStatus, AlertVariant } from './AlertProvider'
import styles from './Alert.module.scss'

// Alto's Box margin scale, minus responsive values and 'auto'
type AlertSpacing = Exclude<Extract<NonNullable<BoxProps['marginTop']>, string>, 'auto'>

export type AlertProps = Omit<HTMLAttributes<HTMLDivElement>, 'role'> & {
  status: AlertStatus
  variant?: AlertVariant
  marginTop?: AlertSpacing
  marginBottom?: AlertSpacing
  'data-testid'?: string
}

const toSpace = (spacing?: AlertSpacing) => {
  if (!spacing) {
    return undefined
  }
  return spacing === 'none' ? 0 : `var(--alto-sem-space-${spacing})`
}

export const Alert = ({
  status,
  variant = 'standard',
  marginTop,
  marginBottom,
  className,
  style,
  ...props
}: AlertProps) => {
  const mergedStyle: CSSProperties = {
    ...style,
    ...(marginTop && { marginTop: toSpace(marginTop) }),
    ...(marginBottom && { marginBottom: toSpace(marginBottom) }),
  }

  return (
    <AlertProvider status={status} variant={variant}>
      <div
        {...props}
        data-status={status}
        role="alert"
        className={classNames(
          styles.container,
          variant !== 'standard' && styles[variant],
          className
        )}
        style={mergedStyle}
      />
    </AlertProvider>
  )
}
